import React, { useEffect } from 'react';

const alwaysSelectedFields = [
  { key: 'origin', label: 'Origin' },
  { key: 'destination', label: 'Destination' },
  { key: 'mktcarrier', label: 'Carrier' },
  { key: 'opcarrier', label: 'Op. By' },
  { key: 'effdt', label: 'Date' },
];

const expandedFields1 = [
  { key: 'origin_name', label: 'Origin City' },
  { key: 'destination_name', label: 'Destination City' },
  { key: 'destination_country', label: 'Destination Country' },
  { key: 'destination_region', label: 'Destination Region' }, 
  { key: 'mktcarrier_name', label: 'Carrier Name' },
  { key: 'opcarrier_name', label: 'Op. By Name' }, 
];

const availableFields = [
  { key: 'fltnum', label: 'Flt #' },
  { key: 'fleet', label: 'Aircraft Type' },
  { key: 'arvtime', label: 'Arr. Time' },
  { key: 'dep_count', label: 'Total Flights' },
  { key: 'dupleg_flight', label: 'Code Share Flights' }, 
  { key: 'deptime', label: 'Dep. Time' },
  { key: 'totSeats', label: 'Seats' },
  { key: 'dupleg', label: 'Code Share' }, 
  { key: 'cs_flights', label: 'Code Share Flights' },
    { key: 'flight_time', label: 'Flight Time' },
    { key: 'origin_name', label: 'Origin City' },
      { key: 'origin_country', label: 'Origin Country' },
  { key: 'origin_region', label: 'Origin Region' }, 
  { key: 'destination_name', label: 'Destination City' },
  { key: 'destination_country', label: 'Destination Country' },
  { key: 'destination_region', label: 'Destination Region' }, 
  { key: 'mktcarrier_name', label: 'Carrier Name' },
  { key: 'opcarrier_name', label: 'Op. By Name' },   
];

const displayOrder = [
  'origin', 'destination', 'mktcarrier', 'opcarrier', 'effdt',
  'fltnum', 'deptime', 'arvtime',  'fleet', 'totSeats','dep_count', 'flight_time', 
  ,  'origin_name','origin_country','origin_region', 'destination_name','destination_country','destination_region','mktcarrier_name','opcarrier_name','dupleg_flight',
  //...expandedFields.map(f => f.key)
];

const FieldSelector = ({ draftFields, onFieldChange }) => {
  useEffect(() => {
    alwaysSelectedFields.forEach(field => {
      if (!draftFields.includes(field.key)) {
        onFieldChange(field.key, true);
      }
    });
  }, []); // Run once on mount

  const handleToggle = (fieldKey, isChecked) => {
    if (fieldKey === 'o_d_c_name' && fieldKey === 'dupleg_flight') {
      onFieldChange(fieldKey, isChecked);
     } else {
      onFieldChange(fieldKey, isChecked);
    }
  };

  const allFieldsToRender = [
    ...alwaysSelectedFields,
    ...availableFields,
  ];

  const sortedFields = displayOrder
    .map(key => allFieldsToRender.find(f => f.key === key))
    .filter(Boolean);

  return (
    <div className="card mb-4">
      <div className="card-body">
        <h5 className="card-title mb-3">Select Additional Fields to Display</h5>

        <div className="row">
          {sortedFields.map((field) => {
            const isAlwaysSelected = alwaysSelectedFields.some(f => f.key === field.key);
            if (isAlwaysSelected) return null;

            return (
              <div key={field.key} className="col-md-3 mb-2">
                <div className="form-check">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id={`chk-${field.key}`}
                    checked={draftFields.includes(field.key)}
                    onChange={(e) => handleToggle(field.key, e.target.checked)}
                  />
                  <label className="form-check-label" htmlFor={`chk-${field.key}`}>
                    {field.label}
                  </label>
                </div>
              </div>
            );
          })}
        </div>

        <div className="mt-2">
          <small className="text-muted">
            Additional Fields Selected: {draftFields.length-5} field{draftFields.length !== 1 ? 's' : ''}
          </small>
        </div>
      </div>
    </div>
  );
};

export default FieldSelector;
